import { SET_ALERT_MANAGER_TYPE, SET_BLOCKING_ALERT_VIEWED, CLEAR_BLOCKING_ALERT_VIEWED_IDS } from 'actions/types';

const INITIAL_STATE = {
  alertManagerType: null,
  viewedBlockingAlertIds: [],
};

const alertsManager = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_ALERT_MANAGER_TYPE:
      return Object.assign({}, state, {
        alertManagerType: action.alertType,
      });
    case SET_BLOCKING_ALERT_VIEWED:
      return Object.assign({}, state, {
        viewedBlockingAlertIds: [...state.viewedBlockingAlertIds, action.id],
      });
    case CLEAR_BLOCKING_ALERT_VIEWED_IDS:
      return Object.assign({}, state, {
        viewedBlockingAlertIds: [],
      });
    default:
      return state;
  }
};

export default alertsManager;
